<template lang='pug'>
  blue-layout(:user='user' :account='account' :biz='biz')
    template(v-slot:default='props')
      bf-notice(@close='message = ""' :message='message')

      bf-modal#congrats-modal( :show='account.id && !account.congratulated' )
        .container.widest
          h3.heading {{$t("Business profile created")}}!
          p {{$t("You have successfully created your business profile.  You may start to use your business page to accept customers’ reservations.")}}
          p {{$t("You may find the merchant function control at the bottom of the screen.")}}
          bf-divider.card
          p {{$t("Here is your business page's URL")}}: 
            router-link(:to='{ name: "merchant", params: {id: biz.id}}' @click='seen') 
              span.url(@click='seen') https://app.bluefaucet.com/m/{{biz.id}}
          bf-divider.card
          
          p {{$t("We would suggest your first step to create your items for selling")}}.
          span {{$t("For service")}}: 
          router-link(:to='{ name: "services"}') 
            span.url2( @click='seen') {{$t("Click Here")}}
          span , 
          span {{$t("For product")}}: 
          router-link.url2(:to='{ name: "products"}') 
            span.url2( @click='seen') {{$t("Click Here")}}
          p
            router-link(:to='{ name: "selling" }')
              img.navbar(src='/ui/addselling.png'  @click='seen')
          p {{$t("Please contact us if you have any questions")}}.
          p {{$t("Thank you")}}!
          p
            button(@click='seen')
              span {{$t("Go to Dashboard")}}
          button.close(@click='seen')
            close-icon
          
          
        #highlight

      bf-modal#addsrvs-modal( v-if='modals.srvs' :show='account.congratulated && !srvs.length && !prds.length && !cats.length' )
        .container
          h5.heading.centered-text {{ $t("You do not have any selling item") }}
          router-link.centered-text( :to='{ name: "services" }')
            bf-button.bright.large.wide.tall
              template(v-slot:text) {{ $t('Add Item') }}
          span.primary.acknowledge-button( @click='modals.srvs = false' ) {{ $t('Skip for now') }}

      bf-modal#addcsts-modal( v-if='modals.csts' :show='!modals.srvs && !csts.length && srvs.length' )
        .container
          h5.heading.centered-text {{ $t('You do not have any Customer') }}
          router-link.centered-text( :to='{ name: "customers" }' )
            bf-button.bright.large.wide.tall
              template(v-slot:text) {{ $t('Add Customer') }}
          span.primary.acknowledge-button( @click='modals.csts = false' ) {{ $t('Skip for now') }}

      base-modal#rsv-overlay(
        :show='!!rsv'
        :user='user',
        :account='account',
        :biz='biz',
        :data='rsv',
      )
        modal-wrapper.max-800( @close='rsv = false' )
          template(v-slot:header)
            h3 {{ $t('Reservation/Appointment Details') }}
          template(v-slot:contents)
            rsv-dtls( :rsv='rsv' )
            rsv-msgs#rsv-msgs(
              v-if='rsv && account && !rsv.name'
              :rsv='rsv'
              :account='account'
              :key='rsv.id'
            )
          template( v-if='rsv.name' v-slot:footer )
            .footer-ctnr
              bf-button.small.tall.narrowest.delete(@click.native='cancel')
                template(v-slot:text) {{ $t('Cancel Event') }}

      #dashboard.view
        section#status.container
          bf-wrapper.container
            base-card.status.padded.roomy(v-if='biz')
              div.company-status
                div.logo
                  router-link(:to='{ name: "merchant", params:  {id: biz.id} }')
                    img(:src='biz.logo' width="40")
                div.cname
                  h3.title
                    router-link(:to='{ name: "merchant", params: {id: biz.id}}') {{ biz.name }}
                div.calendar
                  router-link( :to='{ name: "schedule" }' )
                    img(src='/ui/calendar-b.svg' width='30')

                div.pageurl
                  router-link(:to='{ name: "merchant", params: {id: biz.id}}') https://app.bluefaucet.com/m/{{biz.id}}
                div.cstatus
                  bf-input.basic
                    select(@click='show.status = true' :disabled='show.status')
                      option {{ $t(`${status.title}`) }} {{ details }}
                div.guide
                  bf-input.basic
                    select(v-model="newguide" @change='ChangeRoute')
                      option( value="dashboard") {{ $t("I want to ...")}}
                      option( value="customers|new") {{ $t("Add Customer")}}
                      option( value="customers|cat") {{ $t("Create Customer category")}}
                      option( value="services|serv") {{ $t("Add Service")}}
                      option( value="services|cat") {{ $t("Create Service category")}}
                  
              .status-container(v-show='show.status')
                .close.actionable(@click='show.status = false')
                  img(src='/ui/close.svg' width="30")

                h5.heading {{ $t("Merchant Status")}}

                form(@submit.prevent='set_status')
                  section.previewable
                    h6 {{$t("Merchant Page")}}
                    .status
                      bf-button.narrow.preview( @click.native ='$router.push({ name: "merchant", params: {id: biz.id} })' )
                        template(v-slot:text) {{ $t('View') }}

                      input.radio(type='radio' v-model='status.title' value='Unavailable')
                      span.text {{ $t('Offline') }}

                  section
                    .status
                      input.radio(type='radio' v-model='status.title' value='Available')
                      span.text {{ $t('Available') }}
                    .status
                      input.radio(type='radio' v-model='status.title' value='Be back soon')
                      span.text {{ $t('Be back soon') }}
                    .status
                      input.radio(type='radio' v-model='status.title' value='Be back in')
                      span.text
                        span {{ $t('Be back in') }}
                        select(v-model='status.duration' :required='status.title == "Be back in"')
                          option(value='10') {{ $t('10 mins') }}
                          option(value='20') {{ $t('20 mins') }}
                          option(value='30') {{ $t('30 mins') }}
                          option(value='40') {{ $t('40 mins') }}
                          option(value='50') {{ $t('50 mins') }}
                          option(value='10') {{ $t('1 hr') }}
                    .status
                      input.radio(type='radio' v-model='status.title' value='Be back at')
                      span.text {{ $t('Be back at') }}
                      input(type='text' v-model='status.time' :required='status.title == "Be back at"')
                    .status
                      input.radio(type='radio' v-model='status.title' value='On vacation')
                      span.text {{ $t('On vacation') }}
                    .status
                      input.radio(type='radio' v-model='status.title' value='On vacation till')
                      span.text {{ $t('On vacation till') }}
                      input(type='text' v-model='status.till' :required='status.title == "On vacation till"')
                    .status-details
                      input(v-model='status.subtitle' type='text' :placeholder='$t("Your message")')

                    
                    .set-button-container
                      bf-button.narrow(type='submit')
                        template(v-slot:text) {{ $t('Set') }}
            
            table
              tr
                th
                  h6 {{$t("Customers")}}
                th  
                  h6 {{ $t("Reservations")}}
              tr
                td
                  span {{ $t("Total Customers")}}:  
                  span.number {{ csts.length }}
                td
                  span {{ $t("Total Reservations")}}: 
                  span.number {{ rsvs.length }}
              tr(v-if="1==0")
                td
                  span {{ $t("Active Customers")}}: 0
                td
                  span {{ $t("Today's reservations")}} {{ 0}}
              tr
                td
                  span(v-if="1==0") {{ $t("Invited Customers")}}: 0
                td
                  span {{ $t("Upcoming reservations")}} 
                  span.number {{ upcoming.length}}
                  

        section#add
          bf-wrapper
            form(v-if="1==0" @submit.prevent='add_customer')
              .add-customer.fields
                label {{ $t('Add Customer') }}:
                input( v-model='customer.name' type='text' :placeholder='$t("Name")' required )
                input( v-model='customer.email' type='email' :placeholder='$t("Email")' required )
                bf-button.send-invitation-button( type='submit' @click.native='customer.invitation.invited = true' )
                  template(v-slot:text) {{ $t('Add Customer') }}
            form(@submit.prevent='add_event')
              p.title2 {{ $t('Add Custom Event') }}: 
              p.title2 ({{$t("Personal break, not registered customer appointment, ...")}})
              .add-event.fields
                datetime( v-model='evt.datetime.start' :minute-step='15' type='datetime' :placeholder='$t("Start")' :use12-hour='true')
                datetime( v-model='evt.datetime.end' :minute-step='15' type='datetime' :placeholder='$t("End")' :use12-hour='true' )
                input.fwidth( v-model='evt.name' type='text' :placeholder='$t("Event Name")' )
                bf-button.send-invitation-button( type='submit' @click.native='customer.invitation.invited = true' )
                  template(v-slot:text) {{ $t('ADD') }}

        section#schedule
          bf-wrapper
            template()
              #upcoming(v-if='upcoming.length')
                h3.white {{ $t("Upcoming Events")}}
                base-card.upcoming
                  table
                    thead
                      tr
                        th {{ $t('Date') }}/{{ $t('Time') }}
                        th {{ $t('Customer') }}/{{ $t('Details') }}
                    tbody
                      tr(
                        v-for='r in upcoming'
                        :class='{ pending: r.status == "Pending Cancellation" }'
                      )
                        td.date {{ r.datetime.start.toDate().toLocaleDateString() }} 
                          span {{ r.datetime.start.toDate().toLocaleTimeString( [], { hour: '2-digit', minute: '2-digit' } ) }}
                        td {{ r.account ? r.account.username || r.account.email : 'N/A' }}
                          .actionable.dtls( @click='rsv = r' ) {{ r.service ? r.service.title : r.name }}
              h5.centered-text.white(v-else) {{ $t('You Have No Upcoming Events') }}

      bf-modal#business-modal.align-left(:show='show.modal')
        .container.wide
          h4.heading {{ $t("This is the dashboard for Merchant functions")}}
          p
            span {{ $t("If you'd like to add your services")}}
            router-link(:to='{ name: "services" }') {{ $t("click here!")}}
          p
            span {{ $t("If you'd like to add your customers")}}
            router-link(:to='{ name: "customers" }') {{$t("click here!")}}
          span.primary.acknowledge-button( @click='show.modal = false' ) Close
        #highlight
</template>

<script>
  import { db, firebase } from '@/main'
  import { View } from '@/mixins/view'
  import BaseCard from '@/components/base-card'
  import VueTelInput from 'vue-tel-input'
  import BaseModal from '@/components/modals/base'
  import ModalWrapper from '@/components/modals/wrapper'


  export default {
    name: 'view.dashboard',

    mixins: [ View ],

    components: {
      BaseCard,
      VueTelInput,
      BaseModal,
      ModalWrapper
    },

    data() {
      return {
        rsv: false,
        status: { title: 'Be back soon', duration: '', time: '', till: '', subtitle: '' },
        show: { status: false, rsv: false, modal: this.$route.params.onboarding },
        customer: { invitation: { invited: false }, phone: ''},
        customers: [],
        message: '',
        newguide: 'dashboard',
        evt: { datetime: {} },
        rsvs: [],
        evts: [],
        skip: { srvs: false, csts: false }
      }
    },

    firestore() {
      if( this.biz.id ) return {
        rsvs: {
          ref: db.collection( 'reservations' ).where( 'business_id', '==', this.biz.id ),
          resolve: docs => docs.forEach( doc =>
            db.collection( 'accounts' ).doc( doc.account_id ).get().then( snap => this.$set( doc, 'account', snap.data() ) ) 
          )
        },
        evts: db.collection( 'events' ).where( 'business_id', '==', this.biz.id ),
        customers: {
          ref: db.collection( 'customers' ).where( 'business_id', '==', this.biz.id )
        }
      }
    },

    computed: {
      details() {
        switch( this.status.title ) {
          case 'Be back in': return this.status.duration
          case 'Be back at': return this.status.time
          case 'On vacation till': return this.status.till
          default: return ''
        }
      },

      upcoming() {
        return this.rsvs
        .concat( this.evts )
        .filter( r => r.datetime.start.toDate() > new Date() )
        .filter( n => n.status != "Canceled").sort( (a,b) => a.datetime.start - b.datetime.start )
        .slice(0,10)
      }
    },

    watch: {
      biz(curr, prev) {
        if ( curr && curr.status ) this.status = curr.status
        if ( curr.id ) {
          this.$binding( 'rsvs', db.collection( 'reservations' ).where( 'business_id', '==', curr.id ) ).then( docs =>
            docs.forEach( doc => db.collection( 'accounts' ).doc( doc.account_id ).get().then( snap => this.$set( doc, 'account', snap.data() ) ) )
          )
          this.$binding( 'evts', db.collection( 'events' ).where( 'business_id', '==', curr.id ) )
        }
      }
    },

    methods: {
      seen() {
        db.collection( 'accounts' ).doc( this.account.id ).update({ congratulated: true })
      },

      cancel() {
        db.collection( 'events' ).doc( this.rsv.id ).delete().then( () => this.rsv = false )
      },

      ChangeRoute(){
        this.temp = this.newguide.split('|')
        this.$router.push({ name: this.temp[0], params: { hilight: this.temp[1]}})
      },

      notify(msg) {
        this.message = this.message + msg
      },

      save(account, msg) {
        db.collection( 'customers' ).add({
          ...this.customer,
          ...{
            business: {name: this.biz.name},
            business_id: this.biz.id,
            account: account ? account.data() : {},
            account_id: account ? account.id : ''
          }
        }).then( () => {
          this.notify(msg)
          this.show.single = false
        })
      },

      view(r) {
        this.rsv = r
      },

      set_status() {
        this.account.status = this.status
        // db.collection( 'accounts' ).doc( this.account.id ).update( this.account ).then( () =>
        //   this.show.status = false
        // )
        db.collection( 'businesses' ).doc( this.biz.id ).update({ status: this.status }).then( () =>
          this.show.status = false
        )
      },

      add_event() {
        console.log('evt', this.evt)
        let evt = { 
          business_id: this.biz.id,
          name: this.evt.name,
          datetime: {
            start: firebase.firestore.Timestamp.fromDate( new Date( this.evt.datetime.start ) ),
            end: firebase.firestore.Timestamp.fromDate( new Date( this.evt.datetime.end ) )
          }
        }
        db.collection( 'events' ).add( evt ).then( doc => 
          this.notify(this.$t('Event added to calendar'))
        )
      },

      invite() {
        this.customer.invitation = { invited: true, joined: false }
        db.collection( 'customers' ).add({
          ...this.customer,
          ...{
            business: {name: this.biz.name},
            business_id: this.biz.id
          }
        }).then( () => {
          this.notify(`An invitation will be sent to ${this.customer.email}`)
          this.show.single = false
        })
      },

      async make(acc) {
        this.customer.invitation = { invited: true, joined: true }
        // check if customer with same email exists
        let snap = await db.collection( 'customers' ).where( 'business_id', '==', this.biz.id ).get()
        if ( !snap.docs.length ) db.collection( 'customers' ).add({
          ...this.customer,
          ...{
            business: { name: this.biz.name },
            business_id: this.biz.id,
            account: acc,
            account_id: acc.id
          }
        }).then( () => {
          this.notify(`Account with email ${this.customer.email} exists and will be added as a customer`)
          this.show.single = false
        })
        else this.notify( `Customer with email ${this.customer.email} already exists!` )
      },

      async add_customer() {
        let snap = await db.collection( 'accounts' ).where( 'email', '==', this.customer.email ).get()
        if ( snap.docs.length ) this.make({ id: snap.docs[0].id, ...snap.docs[0].data() })
        else this.invite()
      }
    },

    created() {
      if ( this.biz && this.biz.status ) this.status = this.biz.status
    }
  }
</script>

<style scoped lang='stylus'>
  .footer-ctnr
    padding 16px
    text-align center
  .skip
    color blue
    cursor pointer
  #rsv-msgs
    margin-top 32px
  .url
    text-align center
    margin-top 10px
    color blue
    font-weight bold
    font-size 1.2em
  .url2
    color blue
    font-weight bold
    text-decoration underline
  #congrats-modal
    height calc( 98vh - var(--height-merchant-nav) )
    .navbar
      align-item center
      @media(max-width: 560px)
        width 300px
    .close
      position absolute
      top 10px
      right 10px
      background orange
      border-radius 50%
      width 36px
      height 36px
      border 1.5px solid var(--clr-orange)
      font-size .5em
      display flex
      align-items center
      justify-content center
      padding-top 6px
      color white
    .block
      display flex
      align-item center
      justify-content center
    .box
      padding 5px
      background rgb( 31 69 144 )
      vertical-align middle
      margin-right 10px
    .box2
      padding 5px
      vertical-align middle
      margin-right 5px
    #highlight
      max-width 750px
      height calc( 2vh + var(--height-merchant-nav) )
      position fixed
      bottom 0
      animation glowing 1300ms 5
      width 100vw
      z-index 1
      box-sizing border-box
      @media(min-width: 1080px)
        &::before
          content ""
          height var(--height-merchant-nav)
          background rgba( 0 0 0 .5 )
          position fixed
          bottom 0
          left 0
    p > span
      margin-right 5px
    p .link
      color var(--clr-blue-light)
  
  @keyframes glowing 
    0% 
      border-radius 20px
      background-color rgba( 31 69 144 .1)
      box-shadow 0 0 3px #1F4590
    50% 
      border-radius 20px
      background-color rgba( 255 255 255 .5)
      box-shadow 0 0 15px #ffffff
    100% 
      border-radius 20px
      background-color rgba( 31 69 144 .1)
      box-shadow: 0 0 3px #1F4590

  #addsrvs-modal, #addcsts-modal
    text-align center
    .bf-button
      margin-top 32px

  #business-modal
    a
      color var(--clr-blue-light)
      margin 0 4px

  #dashboard
    .container
      background rgb(245 245 245)
      
    select
      margin 0
    td a
      border-bottom 1px dotted
      padding 5px
    .number
      color red
      font-size 1.2em
      font-weight bold
    table
      width 100%
      tr
        :first-child
          border-top-left-radius 5px
        :last-child
          border-top-right-radius 5px
        th
          :first-child
            border-top-left-radius 5px
          :last-child
            border-top-right-radius 5px
          text-align left
          color black
          padding 10px 10px
          background lightgray
        td
          color black
          font-size 1.1em
          background white
          padding 10px 10px

  #status
    background rgb( 240 240 240 )
    .bf-wrapper
      display grid
      grid-template-columns 1fr 1fr
      grid-gap 20px
      .status .title
        margin-bottom 16px

      @media( max-width: 800px )
        grid-template-columns 1fr
  
  #add
    form:first-child
      margin-bottom 10px
      
    >>> input
      background rgb( 255 255 255 )
      border-radius 5px
      border solid 1px
      padding 10px 15px
      margin 0 5px
      width 130px
      
    label
      font-weight bold
      margin-right 10px
    
    .fields
      display flex
      align-items center
      justify-content center
      margin-top 10px
      @media( max-width: 440px )
        flex-direction column
        > *
          margin-top 16px
          &:first-child
            margin-top 0
      .fwidth
        width 250px
    
    .title2
      display flex
      justify-content center
      font-size 1.1em
      color black
      &:first-child
        font-weight bold
      
  #schedule
    position relative
    background #AAAAAA
    box-shadow var(--shadow-box)
    .white
      color white
    .add-button
      position absolute
      right 12px
      top 18px
      font-size .7em
    h3
      padding 0px 16px 16px 16px
    table
      width 100%
      text-align center
      thead
        font-weight bold
      tbody
        font-size 1em
      th, td
        padding 16px 24px
        &:first-child
          text-align left
        &:last-child
          text-align left
      .dtls
        color var(--clr-blue)
        text-decoration underline
        font-weight bold
      td
        border-top 1px solid rgba( 0 0 0 .05 )

      tr.pending
        td
          color red
  
  .company-status
    display grid
    width 100%
    grid-template-columns 50px repeat(4, 1fr) 30px
    grid-template-rows 1fr 30px 1fr
    grid-column-gap 10px
    grid-row-gap 10px
    .basic
      background #F1F1E6
      border-radius 5px
    .logo
      grid-area 1 / 1 / 2 / 2
    .cname
      grid-area 1 / 2 / 2 / 6
    .calendar
      grid-area 1 / 6 / 2 / 7
    .pageurl
      grid-area 2 / 1 / 3 / 7
      background orange
      padding 8px
      border-radius 5px
      font-weight bold
      color blue
      text-align center
      
    .cstatus
      grid-area 3 / 1 / 4 / 4
    .guide
      grid-area 3 / 4 / 4 / 7

  section
    .base-card.status
      display flex
      padding 10px
      align-items stretch
      
    .base-card.upcoming
      margin 6px 0
      p
        margin 12px 0

  #status
    position relative
    .status-container
      max-width 640px
      width 240px
      text-align left
      position absolute
      top 100px
      left 38px
      background white
      z-index 1
      box-sizing border-box
      box-shadow var(--shadow-box)
      border-radius 5px
      border 1px solid rgba( 0 0 0 .1 )
      form section
        padding 16px
      .heading
        padding 18px 32px 16px 16px
        cursor pointer
      .previewable
        text-align center
        background rgb( 250 200 0 )
        .status
          align-items center
          margin-top 8px
        .preview
          margin-right 16px

      @media( max-width: 360px )
        left 64px
      .bf-divider
        border-width 2px
        margin-bottom 8px
      .close
        position absolute
        top 10px
        right 10px
        border-radius 50%
      .status
        padding 4px 0
        display flex
        .text, input[type=text]
          margin-left 8px
        input[type=text]
          background rgba( 0 0 0 .08 )
          max-width: 48px
        select
          display inline
          width auto
          margin-left 8px
      .status-details
        padding 2px
        margin-top 16px
        margin-bottom 24px
        input
          border 1px solid rgba( 0 0 0 .1 )
          padding 8px 12px
          width 100%
          border-radius 5px
          box-sizing border-box
      .set-button-container
        text-align center
        margin-top 16px
</style>
